export default {
  "hero.badge": "Independent Resource • Updated Regularly • Multilingual",
  "hero.title": "USFans Spreadsheet — Find Products, Compare Finds & Shop Smarter",
  "hero.subtitle":
    "Explore the USFans Spreadsheet, discover products by category, compare available information, learn about QC, shipping and buying tips, and make better-informed decisions.",
  "hero.trust": "Safety-Focused • QC Insights • Shipping Guides",

  "intro.title": "What Is the USFans Spreadsheet?",
  "intro.p1":
    "The USFans Spreadsheet is a shared product catalog that helps people discover, browse and compare items across many categories — from shoes and clothing to bags, accessories and more.",
  "intro.p2":
    "Instead of searching through endless listings, you can jump straight into a category below, review what is available, and follow the links to learn more on the main website.",

  "categories.title": "Browse USFans Products by Category",
  "categories.subtitle":
    "Pick a category to explore available finds. Each link opens the matching section on the main USFans website.",

  "how.title": "How the Spreadsheet Works",
  "how.step1.title": "Pick a Category",
  "how.step1.text": "Choose a product category from the dropdown or the cards below.",
  "how.step2.title": "Compare Finds",
  "how.step2.text": "Review the available product information and compare what fits your needs.",
  "how.step3.title": "Check QC & Shipping",
  "how.step3.text": "Read our QC and shipping notes so you know what to expect before buying.",
  "how.step4.title": "Continue to Main Website",
  "how.step4.text": "Follow the link to the main website to view details and complete your order.",

  "guide.title": "Read Our Complete Guide",
  "guide.subtitle":
    "New to the USFans Spreadsheet? Our in-depth, original guide walks you through how it works, what to check, and how to buy with confidence.",
  "guide.read": "Read the Guide",

  "articles.title": "Latest Guides & Articles",
  "articles.subtitle":
    "Explore our original, in-depth guides on the USFans Spreadsheet — from QC and shipping to coupons and safety.",
  "articles.readMore": "Read article",

  "faq.title": "Frequently Asked Questions",
  "faq.q1": "What is the USFans Spreadsheet?",
  "faq.a1":
    "It is a shared product catalog that organizes items into categories so you can browse and compare finds more easily.",
  "faq.q2": "Is usfanslink.lol affiliated with USFans?",
  "faq.a2":
    "No. This is an independent informational resource and is not necessarily affiliated with USFans.",
  "faq.q3": "Do I buy products directly on this site?",
  "faq.a3":
    "No. This site links you to the main USFans website, where you can view details and complete your purchase.",
  "faq.q4": "Which languages are supported?",
  "faq.a4":
    "English, French, Spanish and Polish are available through the language switcher in the header.",

  "cta.title": "Ready to Explore the Spreadsheet?",
  "cta.subtitle":
    "Jump into the USFans Spreadsheet, browse products by category and compare finds before you buy.",

  "safety.title": "Safety Note",
  "safety.text":
    "Always verify product details, review QC photos when available, and check shipping terms before completing any purchase. This site provides information only and does not sell products directly.",
};